module.exports = __webpack_public_path__ + "img/minus-disabled.467f6212.svg";